require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-integrated-feeder-road-development-project.json") })
        }
      }, "path---en-us-project-integrated-feeder-road-development-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-integrated-feeder-road-development-project!./.cache/json/en-us-project-integrated-feeder-road-development-project.json
// module id = 530
// module chunks = 231608221292675